/** 车辆相关开始 */
export default [
  {
    path: '/zt/contentJoin',
    name: 'contentJoin',
    component: () => import(/* webpackChunkName: "contentJoin" */ '../../views/zhuanti/ContentJoin.vue'),
    meta: {
      title: '',
    },
  },
]
